// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,


  //Stage Environment Setup
  baseApiUrl:               'https://test.skillsportal.gov.bd/api/base/',
  stpRegistrationApiUrl:    'https://test.skillsportal.gov.bd/api/registration/',
  tamApiUrl:                'https://test.skillsportal.gov.bd/api/tam/',
  tciUrl:                   'https://test.skillsportal.gov.bd/api/tci/',
  stpOperationApiUrl:       'https://test.skillsportal.gov.bd/api/stp-ops/',
  fileServiceApiUrl:        'https://test.skillsportal.gov.bd/api/file/',
  paymentUrl:               'https://test.skillsportal.gov.bd/api/payment/',
  napApiUrl:                'https://test.skillsportal.gov.bd/api/gateway/api/nap-service/',
  pgApiUrl:                 'https://test.skillsportal.gov.bd/api/pg/',
  eventApiUrl:              'https://test.skillsportal.gov.bd/api/gateway/api/event-service/',
  commonServiceApiUrl:      'https://test.skillsportal.gov.bd/api/common/',
  researchAndStudiesApiUrl: 'https://test.skillsportal.gov.bd/api/research/',
  financeApiUrl:            'https://test.skillsportal.gov.bd/api/financing/',
  programAndProjectUrl:     'https://test.skillsportal.gov.bd/api/program/',
  logServiceUrl:            'https://test.skillsportal.gov.bd/api/log/',
  notificationServiceApiUrl:'https://test.skillsportal.gov.bd/api/notification/',
  liveJobOpportunityUrl:    'http://203.80.191.251/',
  appealApiUrl:             'https://test.skillsportal.gov.bd/api/appeal/',

  


  //Local Environment Setup
  // baseApiUrl: 'http://localhost:8201/',
  // stpRegistrationApiUrl: 'http://localhost:8301/api/',
  // tamApiUrl: 'http://localhost:8501/api/',
  // tciUrl: 'http://localhost:8701/api/',
  // stpOperationApiUrl: 'http://localhost:8101/api/',
  // fileServiceApiUrl: 'http://localhost:8401/',
  // paymentUrl: 'http://localhost:8801/api/',
  // napApiUrl: 'http://localhost:8888/api/nap-service/',
  // pgApiUrl: 'http://localhost:8902/api/',
  // eventApiUrl: 'http://localhost:8888/api/event-service/',
  // commonServiceApiUrl: 'http://localhost:8901/api/',
  // researchAndStudiesApiUrl: 'http://localhost:8889/api/',
  // financeApiUrl: 'http://localhost:8903/api/financing/',
  // programAndProjectUrl: 'http://localhost:8905/api/',
  // liveJobOpportunityUrl: 'http://203.80.191.251/',
  // logServiceUrl: 'http://103.92.84.241:8906/',
  // notificationServiceApiUrl: 'http://localhost:8907/api/',
  // appealApiUrl: 'http://localhost:8908/api/appeal/',



  validation: {
    allowedPaymentExtensions: '.pdf,.png,.jpg,.jpeg',
    allowedExtensions: '.pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg',
    maxFileSize: 3,
  },
  autoLogoutTime: {
    inMinute: 30,
  },
  recaptcha: {
    siteKey: '6LfeCUchAAAAACKLeOFSzhIupKp1UegrfOJr28g8',
  },
  roles: {
    stpMasterId: 13,
    stpBasicId: 14,
  },
  language: {
    setDefaultLang: 'bn',
  },
  googleReCaptchaToken: {
    token: "6LdJ7j0rAAAAAJBV-kGhDbJ6l9A49IaPEMcYoQX2"
  },
  testGoogleReCaptchaToken: {
    token: "6LcB8D0rAAAAAJB1gGm6cuXOHxLSjVaV5E7ZpH7j"
  },
  smsConfig:{
    secretKey: "17a212ba796daba41459056739148548234cc434254e171b328c00ae95c6417d"
  }
  // roles: {
  //   stpMasterId: 10,
  //   stpBasicId: 11
  // }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
